import { render, staticRenderFns } from "./EDateCustomize.vue?vue&type=template&id=0485110e"
import script from "./EDateCustomize.vue?vue&type=script&lang=js"
export * from "./EDateCustomize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports